module.exports = __webpack_public_path__ + "static/media/info.26cafd2a.svg";